import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { NxIconModule } from '@allianz/ng-aquila/icon';
import { NxButtonModule } from '@allianz/ng-aquila/button';
import { ButtonIcon, ButtonTypes } from '@retail-portal-santander-frontend/remote-shared-data-access';

@Component({
  standalone: true,
  selector: 'allianz-button[testId]',
  templateUrl: './button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NxButtonModule, NxIconModule],
})
export class ButtonComponent {
  icon = input<ButtonIcon | string>();
  type = input<ButtonTypes>('button');
  testId = input.required<string>();
  nxButtonType = input.required<string>();
  disabled = input<boolean>(false);
  label = input.required<string>();

  // NOTE this cannot be done by `transform` in `icon` signal due to
  // angular's issues with type inferring
  // https://github.com/angular/angular/issues/49161
  iconDefinition = computed<ButtonIcon | null>(() => {
    const value: string | ButtonIcon = this.icon();
    if (!value) return null;
    return this.isIconName(value)
      ? <ButtonIcon>{
          size: 's',
          name: value,
        }
      : value;
  });

  private isIconName(value: string | ButtonIcon): value is string {
    return typeof value === 'string';
  }
}
